module.exports = __webpack_public_path__ + "07994a8e2b9f4c76afaa5410aa64628b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/product-template.png
// module id = ./assets/thumbnails/product-template.png
// module chunks = 2